export default __webpack_public_path__ + "static/media/google.9c3d0b28.svg";